export interface Kachel {
    url: string;
    title: string;
    region: string;
    target: number;
    photo: string;
    price: string;
    stars: number[];
    persons: number;
    bedrooms: number;
    properties: string[];

    map_pos: string;
    map_price: string;
}

export function kachelToHtml(k: Kachel): string {
    let r = "";
    r += '<div class="item-wrapper col-sm-12 col-md-6 margin-2" onmouseover="SearchMap.hoverMarker(' + k.target + ')" onmouseout="SearchMap.hoverMarker(0)">\n';
    r += '    <div class="item">\n';
    r += '        <div class="item-image">\n';
    r += '            <a class="item-photo item-link" href="' + k.url + '" title="' + k.title + ', ' + k.region + '" target="' + k.target + '" style="touch-action: pan-y; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">\n';
    r += '                <div class="item-img-container">\n';
    r += '                    <img data-sizes="auto" class="search" src="' + k.photo + '">\n';
    r += '                </div>\n';
    r += '            </a>\n';
    r += '            <div class="slideshow-controls">\n';
    r += '                <div class="slideshow-back slideshow-control">\n';
    r += '                    <i class="icon md-48 css-icons" data-icon="" data-icon-text="chevron_left" aria-hidden="true"></i>\n';
    r += '                </div>\n';
    r += '                <div class="slideshow-fwd slideshow-control">\n';
    r += '                    <i class="icon md-48 css-icons" data-icon="" data-icon-text="chevron_right" aria-hidden="true"></i>\n';
    r += '                </div>\n';
    r += '            </div>\n';
    r += '            <div class="price-tag-wrapper">\n';
    r += '                <div class="price-tag">\n';
    r += '                    <span class="price-discount" aria-hidden="true" style="display: none;">%</span>\n';
    r += '                    <div class="price-text">\n';
    r += '                        ' + k.price + '\n';
    r += '                    </div>\n';
    r += '                </div>\n';
    r += '            </div>\n';
    r += '        </div>\n';
    r += '        <div class="section-body item-section">\n';
    r += '            <h2 class="acco-title" title="' + k.title + ', ' + k.region + '">\n';
    r += '                <a href="' + k.url + '" target="' + k.target + '">' + k.title + '</a>\n';
    r += '                <span class="brand-primary-1-text quality text-nowrap" data-placement="right" data-original-title="" title="">\n';
    k.stars.forEach(c => {
        r += '<i class="glyphicon glyphicon-star"></i>';
    })
    r += '                </span>\n';
    r += '            </h2>\n';
    if (k.persons > 0) {
        r += '        <div class="basicinfo-wrapper" data-placement="top" data-original-title="" title="">\n';
        r += '            <i class="icon-pers"><span class="css-icons" data-icon="" data-icon-text="people" aria-hidden="true"></span></i>\n';
        r += '            <i class="pers-count">' + k.persons + '</i>\n';
        r += '        </div>\n';
    }
    if (k.bedrooms > 0) {
        r += '        <div class="basicinfo-wrapper" data-placement="top" data-original-title="" title="">\n';
        r += '            <i class="icon-pers"><span class="css-icons" data-icon="" data-icon-text="hotel" aria-hidden="true"></span></i>\n';
        r += '            <i class="pers-count">' + k.bedrooms + '</i>\n';
        r += '        </div>\n';
    }
    r += '            <ul class="list-inline list-amenity">\n';
    k.properties.forEach(p => {
        r += '            ' + p + '\n';
    })
    r += '            </ul>\n';
    r += '        </div>\n';
    r += '    </div>\n';
    r += '</div>\n';

    return r;
}
